module.exports = __webpack_public_path__ + "img/comments-question.844d7bd6.svg";